class UsersBrandsListContainer {
  constructor(
    $location,
    $q,
    appErrorHandler,
    appEvents,
    appSessionCapabilities,
    permissions,
    uimessages,
    users,
    USERS_EVENTS,
  ) {
    'ngInject';

    this.$location = $location;
    this.$q = $q;
    this.appErrorHandler = appErrorHandler;
    this.appEvents = appEvents;
    this.appSessionCapabilities = appSessionCapabilities;
    this.permissions = permissions;
    this.uimessages = uimessages;
    this.users = users;
    this.USERS_EVENTS = USERS_EVENTS;
    this.subMenuItems = {
      current: {
        id: 'accounts',
        selected: true,
        label: 'Accounts Assigned',
      },
      activities: {
        id: 'activities',
        path: '',
        label: 'Activities',
      },
    };
    this.subMenu = [];
    this.loading = false;
    this.canUpdatePermissions = false;
    this.removeSelectionSubscription = this.appEvents.on(
      this.USERS_EVENTS.select,
      (user) => {
        this.user = user;
        this.selectedId = user.id;
        this.loadUser();
      },
    );

    this.removeModalRefreshSubscription = this.appEvents.on(
      this.USERS_EVENTS.modal.save,
      () => {
        this.loadUser();
      },
    );

    this.removeUpdateRefreshSubscription = this.appEvents.on(
      this.USERS_EVENTS.edit.save,
      (user) => {
        this.user.name = user.name;
        this.user.email = user.email;
      },
    );

    this.removeRevokeRefreshSubscription = this.appEvents.on(
      this.USERS_EVENTS.revoke.save,
      () => {
        this.loadUser();
      },
    );

    this.removeBrandAdminRefreshSubscription = this.appEvents.on(
      this.USERS_EVENTS.brandAdmin.save,
      () => {
        this.loadUser();
      },
    );

    this.showRoleSelector = false;
    this.user = {};
    this.actionsTypes = {
      editUser: {
        id: 'edit-user',
        label: 'Edit',
      },
      deleteUser: {
        id: 'delete-user',
        label: 'Delete',
      },
      assignBrand: {
        id: 'assign-brand',
        label: 'Assign account',
      },
    };
    this.headerActions = [];
  }
  $onDestroy() {
    this.removeSelectionSubscription();
    this.removeModalRefreshSubscription();
    this.removeUpdateRefreshSubscription();
    this.removeRevokeRefreshSubscription();
    this.removeBrandAdminRefreshSubscription();
  }
  $onChanges({ selectedId }) {
    const shouldLoad = this.$location.search().refresh !== 'yes';
    if (selectedId && selectedId.currentValue && shouldLoad) {
      this.loadUser();
    } else if (!shouldLoad) {
      this.loading = true;
    }
  }
  loadUser() {
    let result;
    if (this.loading) {
      result = this.$q
      .reject(new Error('The user information is already being requested'));
    } else {
      this.appEvents.emit(this.USERS_EVENTS.load.start, this.selectedId);
      this.loading = true;
      this.showRoleSelector = false;
      result = this.permissions.loadAppRoles()
      .then(() => this.users.byId(this.selectedId))
      .then((user) => {
        this.user = user;
        this.showRoleSelector = this.appSessionCapabilities
        .canUpdateUserRole(this.user);
        this.canUpdatePermissions = this.appSessionCapabilities
        .canUpdateUserPermissions(this.user);
        this.resetHeaderActions();
        this.resetSubMenu();
        this.appEvents.emit(this.USERS_EVENTS.load.success, this.user);
      })
      .catch((error) => {
        this.appErrorHandler.handle(error, 'There was an error loading the user information');
        this.$location.path('/users');
        this.appEvents.emit(this.USERS_EVENTS.load.error, error);
      })
      .then(() => {
        this.loading = false;
        this.appEvents.emit(this.USERS_EVENTS.load.finish);
      });
    }

    return result;
  }
  resetHeaderActions() {
    this.headerActions = [];
    if (this.appSessionCapabilities.canUpdateUserInformation(this.user)) {
      this.headerActions.push(this.actionsTypes.editUser);
    }

    if (this.appSessionCapabilities.canDeleteUser()) {
      this.headerActions.push(this.actionsTypes.deleteUser);
    }

    if (this.appSessionCapabilities.canAssignUserToNewBrand(this.user)) {
      this.headerActions.push(this.actionsTypes.assignBrand);
    }
  }
  resetSubMenu() {
    this.subMenu = [this.subMenuItems.current];
    if (this.appSessionCapabilities.canSeeUserActivities()) {
      this.subMenuItems.activities.path = `/users/${this.user.id}/activities`;
      this.subMenu.push(this.subMenuItems.activities);
    }
  }
  handleHeaderAction(action) {
    switch (action.id) {
    case this.actionsTypes.editUser.id:
      this.openEditUserModal();
      break;
    case this.actionsTypes.deleteUser.id:
      this.openDeleteUserDialog();
      break;
    default:
    case this.actionsTypes.assignBrand.id:
      this.openAssignModal();
      break;
    }
  }
  openEditUserModal() {
    this.appEvents.emit(this.USERS_EVENTS.edit.open, this.user);
  }
  openUpdateModal(brands) {
    this.appEvents.emit(this.USERS_EVENTS.modal.open, this.user, brands, true);
  }
  openAssignModal() {
    this.appEvents.emit(this.USERS_EVENTS.modal.open, this.user, [], false);
  }
  openRevokeModal(brands) {
    this.appEvents.emit(this.USERS_EVENTS.revoke.open, this.user, brands, true);
  }
  openViewModal(brand) {
    this.appEvents.emit(this.USERS_EVENTS.modal.open, this.user, [brand], true);
  }
  openDeleteUserDialog() {
    const { displayName } = this.user;
    const title = `Are you sure you want to delete the user ${displayName}?`;
    const message = 'This will prevent the user from accessing the platform';
    this.uimessages.confirm(title, message, {
      confirmText: 'Delete User',
      destructive: true,
    })
    .then((response) => (response ? this.deleteUser() : {}));
  }
  deleteUser() {
    this.headerActions = [];
    this.loading = true;
    let method;
    if (this.appSessionCapabilities.isBrandAdmin(false)) {
      method = this.users.removeAccess(this.user.id);
    } else {
      method = this.users.delete(this.user.id);
    }

    return method
    .then(() => {
      this.loading = false;
      this.$location.path('/users').search('refresh', 'yes');
    })
    .catch((error) => {
      this.appErrorHandler.handle(error, 'The user couldn\'t be deleted');
      this.loading = false;
      return this.loadUser();
    });
  }
  changeRole(role) {
    if (role.id === 'brand_admin') {
      this.appEvents.emit(this.USERS_EVENTS.brandAdmin.open, this.user);
    } else {
      this.headerActions = [];
      this.loading = true;
      this.permissions.changeUserRole(this.user.id, role.id)
      .catch((error) => {
        this.appErrorHandler.handle(error, 'The user role couldn\'t be updated');
      })
      .then(() => {
        this.loading = false;
        return this.loadUser();
      });
    }
  }
  openRoleSettings(role) {
    switch (role.id) {
    default:
    case 'brand_admin':
      this.appEvents.emit(this.USERS_EVENTS.brandAdmin.open, this.user);
      break;
    }
  }
}

export default {
  controller: UsersBrandsListContainer,
  template: `
    <area-placeholder
      ng-if="!$ctrl.selectedId"
      icon="angle-left"
      text="Choose a user from the left"
    ></area-placeholder>
    <users-brands
      ng-if="$ctrl.selectedId"
      loading="$ctrl.loading"
      user="$ctrl.user"
      brands="$ctrl.user.customer_accounts"
      header-actions="$ctrl.headerActions"
      sub-menu="$ctrl.subMenu"
      can-update-permissions="$ctrl.canUpdatePermissions"
      on-header-action-clicked="$ctrl.handleHeaderAction(action)"
      on-update="$ctrl.openUpdateModal(brands)"
      on-revoke="$ctrl.openRevokeModal(brands)"
      on-view="$ctrl.openViewModal(brand)"
    >
      <users-brands-role-selector>
        <users-role-selector-container
          ng-if="$ctrl.showRoleSelector && $ctrl.headerActions.length > 0"
          user="$ctrl.user"
          on-role-change="$ctrl.changeRole(role)"
          on-role-settings="$ctrl.openRoleSettings(role)"
        ></users-role-selector-container>
      </users-brands-role-selector>
    </users-brands>
  `,
  bindings: {
    selectedId: '<',
  },
};
